// @ts-strict-ignore
import type { AllRouteEndpoints } from "../routeTypes";
export const generativeAiAgentCacheKeys: AllRouteEndpoints[] = [
  "/generative_ai/agents",
  "/generative_ai/agent/:id",
  "/:app_group_id/generative_ai/agents/campaign_qa",
];
